export const omitDeep = (keyToOmit: string) => {
  const omitRecursive = (input: unknown): unknown => {
    if (Array.isArray(input)) {
      return input.map(omitRecursive);
    }
    if (input && typeof input === 'object') {
      const entries = Object.entries(input as Record<string, unknown>)
        .filter(([key]) => key !== keyToOmit)
        .map(([key, value]) => [key, omitRecursive(value)]);
      return Object.fromEntries(entries);
    }
    return input;
  };
  return omitRecursive;
};
